import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function UmbrellaInsuranceStep(): ReactElement {
  const dispatch = useDispatch();
  const { umbrellaInsurancePossessed: umbrellaInsurancePossessed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('have_umbrella_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Umbrella Insurance"
          subHeader="Umbrella insurance is extra liability coverage. This type of insurance
          protects you from large claims or lawsuits that go above your other
          insurance policies."
        />
      </GrayCard>
      <CardPadding>
        <CardHeader header="Do you have umbrella insurance?" subHeader="" />
        <Formik
          initialValues={{ umbrellaInsurancePossessed }}
          onSubmit={onSubmit}
          validationSchema={createYesNoObjectSchema(
            'umbrellaInsurancePossessed'
          )}
        >
          <Form ref={formRef}>
            <YesOrNoStepCreator
              name="umbrellaInsurancePossessed"
              showNotSure={true}
            />

            <NavigationButtons />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { UmbrellaInsuranceStep };
